import { Stack, TextField, Typography } from '@mui/material'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import type { UserFormValues } from '../ZodValidationSchema'

export const SlugField = () => {
  const { control } = useFormContext<UserFormValues>()
  const slug = useWatch({ control, name: 'slug' })
  const preview = (slug ?? '').trim().toLowerCase() || '…'

  return (
    <Stack gap={0.75}>
      <Typography variant="black-14-medium" component="div">
        Имя профиля
      </Typography>
      <Typography variant="black-14-normal" color="text.secondary">
        Будет в ссылке: /users/{preview}. При смене старая ссылка перестанет открываться.
      </Typography>
      <Controller
        name="slug"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            placeholder="ivan-ivanov"
            fullWidth
            size="small"
            inputProps={{ maxLength: 40, 'aria-label': 'Имя профиля' }}
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message}
            onChange={(event) => {
              field.onChange(event.target.value.toLowerCase())
            }}
          />
        )}
      />
    </Stack>
  )
}
